const chartColors = [
  '#B5D397', // Light Green
  '#36a2eb', // Blue
  '#ffa1b5', // Pink
  '#fdb658', // Orange
  '#C8CDF0', // Light Blue
  '#5dc1e9', // Sky Blue
  '#b7f3eb', // Turquoise
  '#7fe79b', // Mint Green
  '#efc77e', // Light Yellow
  '#FF6347', // Tomato
  '#4682B4', // Steel Blue
  '#32CD32', // Lime Green
  '#FFD700', // Gold
  '#FF69B4', // Hot Pink
  '#8A2BE2', // Blue Violet
  '#FF4500', // Orange Red
  '#DA70D6', // Orchid
  '#ADFF2F', // Green Yellow
  '#D2691E', // Chocolate
  '#4B0082', // Indigo
  '#FF1493', // Deep Pink
  '#B5D397', // Light Green
  '#36a2eb', // Blue
  '#ffa1b5', // Pink
  '#fdb658', // Orange
  '#C8CDF0', // Light Blue
  '#5dc1e9', // Sky Blue
  '#b7f3eb', // Turquoise
  '#7fe79b', // Mint Green
  '#efc77e', // Light Yellow
  '#FF6347', // Tomato
  '#4682B4', // Steel Blue
  '#32CD32', // Lime Green
];

export const chartColorsList = chartColors;
